// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__12lxo","title":"ClientCherryInfo_title__1dHTk","itemText":"ClientCherryInfo_itemText__3J09y"};